export const en = {
    nav: {
        home: 'Home',
        about: 'About',
        experience: 'Experience',
        projects: 'Projects',
        skills: 'Skills',
        contact: 'Contact',
        game: 'Game'
    },
    hero: {
        greeting: 'Hi, I am Koen',
        headline: 'Embedded Software Engineer & Technical Computing Student',
        description: 'I thoroughly enjoy solving complex problems within embedded systems and hardware/software integration.',
        download_cv: 'Download CV',
        contact: 'Get in Touch'
    },
    about: {
        title: 'About Me',
        intro: 'Fourth-year Technical Computing student specializing in embedded systems engineering. I am experienced with Raspberry Pi, ESP32, and Arduino. Alongside my embedded expertise, I build full-stack interfaces in Java, React, and Tailwind.',
        skills: [
            'Core programming in C++, C, and Java',
            'Independent PCB design & CAD (Fusion360)',
            'Passionate about IoT and smart hardware'
        ],
        outro: 'I am always eager to learn and take on new technological challenges.'
    },
    experience: { title: 'Experience', educationTitle: 'Education' },
    projects: {
        title: 'Projects',
        viewGithub: 'View on GitHub',
        viewLive: 'View Live'
    },
    skills: { title: 'Skills' },
    contact: {
        title: 'Contact',
        getInTouch: 'Get in Touch',
        description: 'Have a question or want to work together? Send me a message or email me directly.',
        email: 'Email',
        linkedin: 'LinkedIn',
        phone: 'Phone',
        github: 'GitHub',
        form: {
            name: 'Name',
            email: 'Email',
            message: 'Message',
            send: 'Send Message'
        }
    },
    footer: {
        copyright: (year) => `\u00A9 ${year} Koen Lammers. All rights reserved.`,
        top: 'Back to top',
        freelance: 'Freelancing under the alias Protoneering'
    }
};
